import { styles } from './BrandIconsBox.css';
import React from 'react';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { IconName, Icon } from '@jbhi-fi/lanyard-ui/components/Icon';

export type BrandIconsBoxProps = {
  className?: string;
  brandNames: Array<IconName>;
};

export const BrandIconsBox = ({ className, brandNames = [] }: BrandIconsBoxProps) => {
  const maxWidth = Math.round((2 / brandNames.length) * 100);
  return (
    <div className={classNames(styles.brandIconsBox, className)}>
      {brandNames.map((brandName, i) => {
        return (
          <Icon
            key={`${brandName}-${i}`}
            className={styles.brandIcon}
            name={brandName}
            fallback={null}
            style={{ maxWidth: maxWidth > 50 ? '100%' : `${maxWidth}%` }}
          />
        );
      })}
    </div>
  );
};
